import styled from 'styled-components';

// todo: Этот компонент требует доработки, использовался в 2х местах поэтому вынес в ui-react
export const OrderedList = styled.ol`
    padding-left: 16px;
    list-style: decimal;
`;
